/**
 * Swiss Legal Forms
 * TASK-339: Onboarding Wizard UI
 *
 * Common Swiss legal entity forms for EAM firms.
 */

export interface LegalForm {
  value: string;
  label: string;
  description: string;
}

export const SWISS_LEGAL_FORMS: LegalForm[] = [
  {
    value: 'AG',
    label: 'AG (Aktiengesellschaft)',
    description: 'Stock corporation - most common for larger firms',
  },
  {
    value: 'GmbH',
    label: 'GmbH (Gesellschaft mit beschränkter Haftung)',
    description: 'Limited liability company - popular for smaller firms',
  },
  {
    value: 'Einzelfirma',
    label: 'Einzelfirma',
    description: 'Sole proprietorship - single owner business',
  },
  {
    value: 'Kollektivgesellschaft',
    label: 'Kollektivgesellschaft',
    description: 'General partnership - multiple partners with unlimited liability',
  },
  {
    value: 'Kommanditgesellschaft',
    label: 'Kommanditgesellschaft',
    description: 'Limited partnership - mix of general and limited partners',
  },
  {
    value: 'Genossenschaft',
    label: 'Genossenschaft',
    description: 'Cooperative - member-owned organization',
  },
  {
    value: 'Stiftung',
    label: 'Stiftung',
    description: 'Foundation - for charitable or family purposes',
  },
  {
    value: 'Verein',
    label: 'Verein',
    description: 'Association - membership organization',
  },
  {
    value: 'Other',
    label: 'Other',
    description: 'Other legal form not listed above',
  },
];

export const EMPLOYEE_COUNT_RANGES = [
  { value: '1-10', label: '1-10 employees' },
  { value: '11-50', label: '11-50 employees' },
  { value: '51-200', label: '51-200 employees' },
  { value: '200+', label: '200+ employees' },
];

export const INDUSTRY_SPECIALIZATIONS = [
  { value: 'UHNWI', label: 'Ultra High Net Worth Individuals' },
  { value: 'HNWI', label: 'High Net Worth Individuals' },
  { value: 'Family Office', label: 'Family Office' },
  { value: 'Institutional', label: 'Institutional Clients' },
  { value: 'Pension Funds', label: 'Pension Funds' },
  { value: 'Corporate', label: 'Corporate Treasury' },
  { value: 'Private Equity', label: 'Private Equity / Venture Capital' },
  { value: 'General', label: 'General Wealth Management' },
];

export const SRO_MEMBERSHIPS = [
  { value: 'VQF', label: 'VQF (Verein zur Qualitätssicherung)' },
  { value: 'PolyReg', label: 'PolyReg' },
  { value: 'ARIF', label: 'ARIF (Association Romande des Intermédiaires Financiers)' },
  { value: 'SO-FIT', label: 'SO-FIT (Self-Regulatory Organisation of Financial Intermediaries of Ticino)' },
  { value: 'OAR-G', label: 'OAR-G (Organisme d\'Autorégulation de la FIDUCIAIRE SUISSE)' },
  { value: 'Other', label: 'Other SRO' },
  { value: 'None', label: 'Not applicable / Direct FINMA supervision' },
];
